// extracted by mini-css-extract-plugin
export default {"StationOwnerSoonContent":"StationOwnerSoon_StationOwnerSoonContent__ncykW","ownerImg":"StationOwnerSoon_ownerImg__LiQQw","soonLogo":"StationOwnerSoon_soonLogo__bUQKA"};